import React, { useContext, useEffect, useRef } from "react";
import { AccordionContext } from "@src/lms/jelly/extensions/ui/accordion/AccordionContext";
import { Collapsible } from "@src/lms/jelly/extensions/ui/collapsible/Collapsible";

import styles from "./AccordionItem.module.scss";
import classnames from "classnames";

interface AccordionItemProps {
  id: string;
  title: string;
  children: React.ReactNode;
  unmountChildrenWhenHidden?: boolean;
  preventPrerender?: boolean;
  theme?: React.ComponentProps<typeof Collapsible>["theme"];
}

export const AccordionItem: React.FC<AccordionItemProps> = ({
  id,
  children,
  title,
  unmountChildrenWhenHidden,
  preventPrerender,
  theme,
}) => {
  const openedBefore = useRef(false);
  const context = useContext(AccordionContext);
  const open = context.openIds.includes(id);

  useEffect(() => {
    if (open) {
      openedBefore.current = true;
    }
  }, [open]);

  const preventClosedRender =
    (preventPrerender && !openedBefore.current) || (openedBefore.current && unmountChildrenWhenHidden);

  return (
    <div
      className={classnames(styles.root, {
        [styles.themeGhost]: theme === "ghost",
      })}
    >
      <Collapsible open={open} title={title} onToggle={(open) => context.onToggle(id, open)} theme={theme}>
        {(open || !preventClosedRender) && children}
      </Collapsible>
    </div>
  );
};
